import { faCircleNotch, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'
import { PropType } from 'vue'
import { Component, Watch } from 'vue-property-decorator'

import { Featured } from '@skinsoft/types'
import { MovementDataStore } from '@skinsoft/entity'
import { ReactiveVue } from '@skinsoft/reactive-vue'
import { EntityFeaturedCard, FeaturedCard } from '@skinsoft/ui'
import { DELETE_CARD } from '@skinsoft/events'
import { toFeatured$ } from '../../serializer/featured'

@Component({
    components: {
        sEntityFeaturedCard: EntityFeaturedCard,
        sFeaturedCard: FeaturedCard,
    },
    template: require('./movement-featured-card.html'),
    props: {
        needsToFetchFeatured: {
            type: Boolean,
            default: true
        },
        featured: {
            type: Object as PropType<Featured>,
        }
    }
})
export class MovementFeaturedCard extends ReactiveVue {
    public $movementDataStore: MovementDataStore;
    public serializer = toFeatured$;

    private needsToFetchFeatured: boolean
    public featured: Featured
    
    private isBeingDeleted = false
    public deleting = false

    public checkIcon = faCheck
    public crossIcon = faTimes
    public circleNotchIcon = faCircleNotch;

    public deleteMovement() {
        if(this.featured?.id) {
            this.deleting = true
            this.$emit(DELETE_CARD, this.featured.id)
        }
        else if(this.needsToFetchFeatured) {
            this.deleting = true
            this.$emit(DELETE_CARD)
        }
    }

    @Watch('featured')
    public onFeaturedChanged() {
        this.isBeingDeleted = false
        this.deleting = false
    }
}
